import React from "react"

import { makeStyles } from '@material-ui/styles'
import { ThemeProvider } from '@material-ui/styles';

import defaultTheme from "src/styles/theme";

import ReactWordcloud from 'react-wordcloud';
import 'tippy.js/dist/tippy.css';
import 'tippy.js/animations/scale.css';

// Utilities
import kebabCase from "lodash/kebabCase"
// Components
import { graphql, navigate } from "gatsby"

import Layout   from "src/components/layout/Layout"
import SEO      from "src/components/seo"


const useStyles = makeStyles(theme => ({
  background: {
    ...defaultTheme.flex.row,
    ...defaultTheme.flex.justifyCenter,
    width: '100%',
    background: defaultTheme.base.colors.white,
  },
  listWrap: {
    ...defaultTheme.flex.col,
    ...defaultTheme.contentWrap,
  }
}))


export default function TagsPage(props) {

  const { data } = props
  const classes = useStyles()
  const title = data.site.siteMetadata.title
  const group = data.allMarkdownRemark.group

  const callbacks = {
    onWordClick: word => {
      navigate(`/tags/${kebabCase(word.text)}`);
    },
    getWordTooltip: word => `${word.text} (${word.value})`,
  }
  const defaultOptions = {
    deterministic: false,
    enableOptimizations: false,
    enableTooltip: true,
    fontFamily: 'Hanna',
    fontSizes: [40, 100],
    fontStyle: 'normal',
    fontWeight: 'normal',
    padding: 1,
    // rotationAngles: [0,0],
    rotations: 0,
    scale: 'sqrt',
    spiral: 'rectangular',
    tooltipOptions: {},
  };

  return (
    <ThemeProvider theme={defaultTheme}>
      <Layout title={title}>
        <SEO
          title="All posts"
          keywords={[`blog`, `gatsby`, `javascript`, `react`]}
        />
        <div className={classes.background}>
          <ReactWordcloud
            callbacks={callbacks}
            options={defaultOptions}
            words={group}
          />
          </div>
      </Layout>
    </ThemeProvider>
  )
}

export const pageQuery = graphql`
  query {
    site {
      siteMetadata {
        title
      }
    }
    allMarkdownRemark(limit: 2000) {
      group(field: frontmatter___tags) {
        text: fieldValue
        value: totalCount
      }
    }
  }
`